import React from "react";
import { IBucketCreateRequest } from "api/entities/bucket";
import { FormFieldError } from "components/shared-ui/form/form-field-error/form-field-error";
import { FormFieldLabel } from "components/shared-ui/form/form-field-label/form-field-label";
import { FormFieldValue } from "components/shared-ui/form/form-field-value/form-field-value";
import { FormField } from "components/shared-ui/form/form-field/form-field";
import YesNoButtonGroup from "components/shared-ui/yes-no-button-group/yes-no-button-group";
import styles from "./bucket-immutable-section.module.scss";

export interface IBucketImmutableSectionErrors {
  objectLock?: string;
  objectVersioning?: string;
}
const ObjectLockWarning =
  "When you disable object lock, Myota immutability will store previous versions and delete markers indefinitely.";
export interface IBucketImmutableSectionProps {
  bucketCreateUpdateRequest: IBucketCreateRequest;
  disabled?: boolean;
  errors: IBucketImmutableSectionErrors;
  onChange: (bucketUpdate: Partial<IBucketCreateRequest>) => void;
  onError: (errors: Partial<IBucketImmutableSectionErrors>) => void;
  className?: string;
}

export function BucketImmutableSection(props: IBucketImmutableSectionProps) {
  function handleChange(bucketUpdate: Partial<IBucketCreateRequest>) {
    props.onChange({ ...props.bucketCreateUpdateRequest, ...bucketUpdate });
  }

  return (
    <>
      <FormField testId="object-lock-field" className={props.className}>
        <FormFieldLabel className={styles.label}>Object Lock:</FormFieldLabel>
        <FormFieldValue>
          <YesNoButtonGroup
            autoFocus={false}
            disabled={props.disabled}
            value={props.bucketCreateUpdateRequest.objectLock}
            onChange={(objectLock) => handleChange({ objectLock })}
          />
        </FormFieldValue>
        {!props.bucketCreateUpdateRequest.objectLock && (
          <FormFieldError error={ObjectLockWarning} />
        )}
        <FormFieldError error={props.errors.objectLock} />
      </FormField>

      {/* <FormField
                testId="object-versioning-field"
                className={props.className}
            >
                <FormFieldLabel className={styles.label}>
                    Object Versioning:
                </FormFieldLabel>
                <FormFieldValue>
                    <YesNoButtonGroup
                        autoFocus={false}
                        disabled={props.disabled}
                        value={props.bucketCreateUpdateRequest.objectVersioning}
                        onChange={(objectVersioning) => handleChange({ objectVersioning })}
                    />
                </FormFieldValue>
                <FormFieldError error={props.errors.objectVersioning}/>
            </FormField> */}
    </>
  );
}
